<template>
  <div class="col-md-3 sidebar sidebar-right p-md-3 d-flex flex-column">
    <div class="sub-title">Offerteoverzicht</div>

    <app-materials @openSawingSchedule="openSawingSchedule"/>
    <app-sawing-schedule ref="appSawingSchedule"/>
    <app-restmaterials/>
    <app-summary/>

  </div>
</template>

<script>
  import Materials from '@/components/Tool/Overview/Materials.vue'
  import SawingSchedule from '@/components/Tool/Overview/SawingSchedule.vue'
  import RestMaterials from '@/components/Tool/Overview/RestMaterials.vue'
  import Summary from '@/components/Tool/Overview/Summary.vue'

  export default {
    components: {
      'app-materials': Materials,
      'app-sawing-schedule': SawingSchedule,
      'app-restmaterials': RestMaterials,
      'app-summary': Summary
    },
    methods: {
      openSawingSchedule(materialId) {
        this.$refs.appSawingSchedule.showModal(materialId)
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
